module.exports = __webpack_public_path__ + "static/media/asian-taxi-thailand-svgrepo-com.f60c9e38.svg";